export type IkasStorefontMetaTemplates = {
  descriptionTemplate: string | null;
  locale: string | null;
  pageType: StorefrontPageTypesEnum | null;
  titleTemplate: string | null;
};

export enum StorefrontPageTypesEnum {
  BLOG = "BLOG",
  BLOG_CATEGORY = "BLOG_CATEGORY",
  BRAND = "BRAND",
  CATEGORY = "CATEGORY",
  CUSTOM = "CUSTOM",
  PRODUCT = "PRODUCT",
}
